module.exports = __webpack_public_path__ + "img/flashsale-cont.44126a34.png";